import { render } from "./Weights.vue?vue&type=template&id=38f723c8"
import script from "./Weights.vue?vue&type=script&lang=js"
export * from "./Weights.vue?vue&type=script&lang=js"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__